export const tr = {
    'Selected-of-regions': 'Toplam {totalRegionCount} şehirden {currentRegionCount} şehir seçildi',
    'all-city': 'Tüm şehirler',
    'delete-screens': 'Ekranları sil',
    'many-screens': '{count} ekran',
    'many-uncheck-confirm-message': 'Seçilenler listesinden {city} şehrindeki {count} ekranı silmek üzeresiniz.',
    'one-screens': '{count} ekran',
    'one-uncheck-confirm-message': 'Seçilen listeden {city} şehrindeki {count} ekranı silmek üzeresiniz.',
    'show-on-map': 'Haritada göster',
    'some-screens': '{count} ekran',
    'some-uncheck-confirm-message': 'Seçilenler listesinden {city} şehrindeki {count} ekranı silmek üzeresiniz.'
};
